<template>
  <section>
    <header>
      <site-title :text="'Photos by Jason'" :textDelay="0.5" />
      <text-block :revealTransition="true" :marginLess="true" :quoteType="true">“What I like about photographs is that they capture a moment that’s gone forever, impossible to reproduce.” <cite>— Karl Lagerfeld</cite></text-block>
    </header>
    <article ref="pictures">
      <div v-if="this.$store.state.flickrData" class="frames">
        <figure v-for="image in this.$store.state.flickrData.slice(0, this.$store.state.numberOfPhoto)" :key="image.id">
          <img :src="image.url_h" :alt="image.title"/>
          <figcaption>{{image.title}}</figcaption>
        </figure>
      </div>
      <div v-else class="frames">
        <figure v-for="n in 6" :key="n">
          <div class="img-placeholder"></div>
          <figcaption>Loading..</figcaption>
        </figure>
      </div>
      <div ref="loadTrigger"></div>
    </article>
    <site-footer />
  </section>
</template>

<script>
  import SiteTitle from '@/components/SiteTitle.vue'
  import TextBlock from '@/components/TextBlock.vue'
  import Footer from '@/components/Footer.vue'
  
  import axios from 'axios'
  import {TweenMax, Power3} from 'gsap'
  import ScrollMagic from 'scrollmagic'
  import 'ScrollMagicIndicator'
  
  export default {
    name: 'photos',
    components: {
      'site-title': SiteTitle,
      'text-block': TextBlock,
      'site-footer': Footer
    },
    data () {
      return {
        flickrUserId: '103073251@N02',
        flickrApiKey: '3c8c001e3b7b80cff8ff75e1404ed604',
        controller: '',
        loadMoreScene: ''
      }
    },
    methods: {
      loadMoreBtnHandler () {
        this.$store.commit('loadMorePhoto', 12)
      },
      fetchImages () {
        return axios({
          method: 'get',
          url: 'https://api.flickr.com/services/rest',
          params: {
            method: 'flickr.photos.search',
            api_key: this.flickrApiKey,
            user_id: this.flickrUserId,
            format: 'json',
            nojsoncallback: 1,
            extras: 'url_h',
            per_page: 500
          }
        })
      }
    },
    created () {
      this.fetchImages()
      .then((response) => {
        this.$store.commit('loadFlickrData', response.data.photos.photo)
      })
    },
    mounted () {
      // Reavel transition for the pics
      TweenMax.fromTo(this.$refs.pictures, 1.5, {opacity: 0, y: 100}, {opacity: 1, y: 0, delay: 1.5, ease: Power3.easeOut})

      // ScrollMagic setup
      this.controller = new ScrollMagic.Controller()

      this.loadMoreScene = new ScrollMagic.Scene({
        triggerElement: this.$refs.loadTrigger,
        triggerHook: 'onEnter'
      })
      .on('enter leave', (e) => {
        if (e.type === 'enter') {
          this.$store.commit('loadMorePhoto', 6)
        }
      })
      .addTo(this.controller)
      // .addIndicators()
    }
  }
</script>

<style lang="scss" scoped>
  section {
    min-height: 100vh;
    overflow: hidden;
    max-width: $size-max-width;
    margin: 0 auto;

    @include device(laptop) {
      padding: 0 60px;
    }

    @include device(mobile) {
      padding: 0 20px;
    }
  }

  header {
    height: calc(100vh - 120px);
    min-height: 600px;
    max-height: 900px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    @include device(tablet) {
      height: 80vh;
    }

    @include device(mobile) {
      min-height: 400px;
    }
  }

  .flickr-loading {
    background-color: slategray;
    text-align: center;
    width: 100%;
    height: 0;
    position: relative;
    padding-bottom: 56.25%;
    margin-bottom: 100px;
  }

  figure {
    margin-bottom: 200px;

    @include device(tablet) {
      margin-bottom: 20vw;
    }

    & figcaption {
      font-style: normal;
      font-size: 0.9rem;
      text-align: center;
      margin-top: 50px;
      color: $color-grey;

      @include device(tablet) {
        font-size: 0.8rem;
        margin-top: 5vw;
      }
    }
  }

  .grid {
    width: 100%;
    max-width: $size-max-width;
    margin: 200px 0;
    display: grid;
    grid-gap: 2px;
    grid-template-columns: repeat(2, 1fr);

    & img {
      width: 100%;
    }
  }

  .frames {
    width: 100%;
    max-width: $size-max-width;

    & img, & .img-placeholder {
      display: block;
      width: 100%;
      background-color: #f4f6f9;
      border-radius: 3px;
      min-height: 640px;

      @include device(laptop) {
        min-height: auto;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/Photos.vue